"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecentApiResponseExtractChannel = exports.RecentsUsersExtractChannel = void 0;
var microview_communication_service_1 = require("@tableau/microview-communication-service");
// tslint:disable-next-line:no-any
var RecentsUsersExtractChannel = /** @class */ (function (_super) {
    __extends(RecentsUsersExtractChannel, _super);
    function RecentsUsersExtractChannel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'RecentUsersExtractChannel';
        _this.namespace = 'VPC.RecentsAPI';
        return _this;
    }
    return RecentsUsersExtractChannel;
}(microview_communication_service_1.MicroviewCommunicationChannel));
exports.RecentsUsersExtractChannel = RecentsUsersExtractChannel;
// tslint:disable-next-line:no-any
var RecentApiResponseExtractChannel = /** @class */ (function (_super) {
    __extends(RecentApiResponseExtractChannel, _super);
    function RecentApiResponseExtractChannel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'ContentSuggestionExtractChannel';
        _this.namespace = 'VPC.RecentsAPI';
        return _this;
    }
    return RecentApiResponseExtractChannel;
}(microview_communication_service_1.MicroviewCommunicationChannel));
exports.RecentApiResponseExtractChannel = RecentApiResponseExtractChannel;
//# sourceMappingURL=RecentsAPIChannels.js.map